import component from './payment-method.component';

export default angular
  .module('fizyweb.paycell.paymentMethod', [])
  .component('fizyPaycellPaymentMethod', component).name;



// WEBPACK FOOTER //
// src/app/buy/payment-method/payment-method.module.ts